import { useOsmNames } from '../hooks/useOsmNames.tsx';
import DashboardLink from './DashboardLink.tsx';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

export default function DashboardNavigation() {
  const { data: sensorList, loading } = useOsmNames();

  if (loading) return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
      <CircularProgress size={24} sx={{ color: '#1D9E75' }} />
    </Box>
  );

  return (
    <Box className="dl-grid">
      <DashboardLink title="Overview" linkto="overview" />
      {sensorList.map(sensor => (
        <DashboardLink
          key={sensor.osm_name}
          title={sensor.description?.trim() || sensor.osm_name}
          linkto={sensor.osm_name}
        />
      ))}
    </Box>
  );
}
